import { createContext, useContext, type ReactNode, type FC } from 'react'
import { type ConversationsPageLayoutStore } from 'pages/conversations/store/conversationsPageLayoutStore'

export const ConversationsPageLayoutContext = createContext<ConversationsPageLayoutStore | null>(
  null
)

export const useConversationsPageLayoutContext = () => {
  const context = useContext(ConversationsPageLayoutContext)

  if (context === null)
    throw new Error(
      'You have forgotten to wrap your root component with ConversationsPageLayoutContext'
    )

  return context
}

type IProviderConversationsPageLayoutProps = {
  value: ConversationsPageLayoutStore
  children: ReactNode
}

export const ProviderConversationsPageLayout: FC<IProviderConversationsPageLayoutProps> = ({
  value,
  children,
}) => {
  return (
    <ConversationsPageLayoutContext.Provider value={value}>
      {children}
    </ConversationsPageLayoutContext.Provider>
  )
}
